import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import CopyIcon from "@material-ui/icons/FileCopyOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import { onWebsiteClick, onCopy } from "../TableUtility";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor-linkpoint/ckeditor5-build-classic";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Divider } from "@material-ui/core";
import { searchLang } from "../Languages";

const rawLang = localStorage.getItem("languages");
const lang = (rawLang !== null && !isNaN(rawLang) && parseInt(rawLang) >= 0 && parseInt(rawLang) <= 2) ? parseInt(rawLang) : 0;

// Move option definitions outside component to prevent recreation on every render
const getOptionDefinitions = (lang) => ({
  Company: [
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "industry_type", label: searchLang.IndustryType[lang], type: "text" },
    { id: "website", label: searchLang.Website[lang], type: "link", onClick: onWebsiteClick },
    { id: "email", label: searchLang.Email[lang], type: "text" },
    { id: "phone_number", label: searchLang.PhoneNumber[lang], type: "text" },
    { id: "status", label: searchLang.Status[lang], type: "text" },
    { id: "notes", label: searchLang.Notes[lang], type: "editor" }
  ],
  Site: [
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "website", label: searchLang.Website[lang], type: "link", onClick: onWebsiteClick },
    { id: "address", label: searchLang.Address[lang], type: "text" },
    { id: "primary_contact_number", label: searchLang.ContactNumber[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  Document: [
    { id: "name", label:searchLang.Name[lang], type: "text" },
    { id: "category", label: searchLang.Category[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" },
    { id: "content", label: searchLang.Content[lang], type: "editor" }
  ],
  "Server and Device": [
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "device_type", label: searchLang.DeviceType[lang], type: "text" },
    { id: "description", label: searchLang.Description[lang], type: "text" },
    { id: "username", label: searchLang.Username[lang], type: "text" },
    { id: "password", label: searchLang.Password[lang], type: "password", onClick: onCopy },
    { id: "tag_number", label: searchLang.TagNumber[lang], type: "text" },
    { id: "location", label: searchLang.Location[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  Service: [
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "username", label: searchLang.Username[lang], type: "text" },
    { id: "password", label: searchLang.Password[lang], type: "password", onClick: onCopy },
    { id: "website", label: searchLang.Website[lang], type: "link", onClick: onWebsiteClick },
    { id: "description", label: searchLang.Description[lang], type: "text" },
    { id: "notes", label: searchLang.Notes[lang], type: "text" },
    { id: "location", label: searchLang.Location[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  "Software License": [
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "serial_number", label: searchLang.SerialNumber[lang], type: "text" },
    { id: "install_date", label: searchLang.InstallDate[lang], type: "text" },
    { id: "software_asset_tag", label: searchLang.SoftwareAssetTag[lang], type: "text" },
    {
      id: "workstation_asset_tag",
      label: searchLang.WorkstationAssetTag[lang],
      type: "text"
    },
    { id: "location", label: searchLang.Location[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  Employee: [
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "email", label: searchLang.Email[lang], type: "text" },
    { id: "phone_number", label: searchLang.PhoneNumber[lang], type: "text" },
    { id: "portal_access", label: searchLang.PortalAccess[lang], type: "text" },
    { id: "location", label: searchLang.Location[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  "Customized Data": [
    { id: "model", label: searchLang.Model[lang], type: "text" },
    { id: "json_schema_name", label: searchLang.SchemaName[lang], type: "text" },
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "searchable", label: searchLang.KeyWords[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  "File": [
    { id: "model", label: searchLang.Model[lang], type: "text" },
    { id: "name", label: searchLang.Name[lang], type: "text" },
    { id: "notes", label: searchLang.Notes[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" }
  ],
  "Domain": [
    { id: "model", label: searchLang.Model[lang], type: "text" },
    { id: "name", label: searchLang.DomainName[lang], type: "text" },
    { id: "registrar", label: searchLang.Registrar[lang], type: "text" },
    { id: "expiration_date", label: searchLang.ExpirationDate[lang], type: "text" },
    { id: "ssl_expiration_date", label: searchLang.SSLExpirationDate[lang], type: "text" },
    { id: "company", label: searchLang.Company[lang], type: "text" },
    { id: "sub_domains", label: searchLang.SubDomains[lang], type: "html" }
  ]
});
const useStyles = makeStyles(theme => ({
  adornedStart: {
    marginRight: "0px !important"
  },
  bold: {
    fontWeight: 600
  },
  copy: {
    cursor: "pointer",
    color: "#909497",
    height: 25,
    width: 25,
    padding: 5,
    border: "1px solid #c4c4c4",
    borderRadius: "4px"
  },
  divider: {
    backgroundColor: theme.dividers
  },
  itemLabel: {
    padding: 5,
    color: theme.text
  },
  link: {
    cursor: "pointer",
    color: theme.linkColorFaded,
    "&:hover": {
      color: theme.linkColor
    }
  },
  passwordIcon: {
    padding: "5px !important"
  },
  passwordField: {
    padding: "5px !important"
  },
  rightSearchPane: {
    padding: 5,
    width: "100%",
    height: "100%"
  },
  rightText: {
    fontSize: "small",
  },
  smallText: {
    fontSize: "small",
    color: theme.text,
    paddingLeft: theme.spacing(3) + "px !important",
    paddingRight: theme.spacing(3) + "px !important"
  },
  title: {
    color: theme.text,
    paddingLeft: theme.spacing(3)
  },
  visibilityIcon: {
    width: ".90rem",
    height: ".90rem"
  },
}));

const ShowDetails = props => {
  const classes = useStyles();
  const [ModelType, setModelType] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [copy, setCopy] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  useEffect(() => {
    setShowPassword(false);
    // Update ModelType when props.data changes
    if (props.data && props.data.model) {
      const optionDefinitions = getOptionDefinitions(lang);
      setModelType(optionDefinitions[props.data.model]);
    } else {
      setModelType(null);
    }
  }, [props.data]);



  const editorConfiguration = {
    toolbar: {
      items: []
    }
  };

  const onEditorInit = editor => {
    editor.editing.view.change(writer => {
      writer.setStyle(
        "height",
        "calc(100vh/4)",
        editor.editing.view.document.getRoot()
      );
    });
  };
  const showProperty = item => {
    if (props.data[item.id]) {
      if (item.type === "password") {
        return (
          <React.Fragment key={item.id}>
            <Grid item xs={4} sm={3} className={classes.smallText}>
              {item.label}
            </Grid>
            <Grid item xs={5} sm={6}>
              <TextField
                key="outlined-password-input"
                type={"text"}
                name="password"
                variant="outlined"
                fullWidth
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      className={classes.adornedStart}
                    >
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="start"
                        className={classes.passwordIcon}
                      >
                        {showPassword ? (
                          <Visibility className={classes.visibilityIcon} />
                        ) : (
                          <VisibilityOff className={classes.visibilityIcon} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                  readOnly: true,
                  className: `${classes.bold} ${classes.smallText}`
                }}
                inputProps={{
                  className: `${classes.passwordField}`
                }}
                value={showPassword ? props.data[item.id] : searchLang.Showpassword[lang]}
              />
            </Grid>
            <Grid item xs={3} sm={3}>
              <Tooltip
                onClose={() => {
                  setCopy(false);
                }}
                title={
                  copy ? (window.innerWidth < 800 && "Copied") || "" : searchLang.Copy[lang]
                }
              >
                <CopyIcon
                  className={classes.copy}
                  fontSize="small"
                  onClick={() => {
                    item.onClick(props, props.data, item.id);
                    setCopy(true);
                  }}
                />
              </Tooltip>
            </Grid>
            <Snackbar
              open={copy}
              autoHideDuration={15000}
              anchorOrigin={{ horizontal: "center", vertical: "top" }}
              onClose={() => setCopy(false)}
            >
              <MuiAlert
                elevation={6}
                variant="filled"
                onClose={() => setCopy(false)}
                severity="success"
              >
                {searchLang.helper1[lang]}
              </MuiAlert>
            </Snackbar>
          </React.Fragment>
        );
      } else if (item.type === "link") {
        return (
          <React.Fragment key={item.id}>
            <Grid item xs={4} sm={3} className={classes.smallText}>
              {item.label}
            </Grid>
            <Grid item xs={8} sm={9}>
              <span
                className={`${classes.rightText} ${classes.link}`}
                onClick={
                  item.onClick
                    ? () => {
                        item.onClick(props, props.data, item.id);
                      }
                    : () => {}
                }
              >
                {props.data[item.id]}
              </span>
            </Grid>
          </React.Fragment>
        );
      } else if (item.type === "editor") {
        return (
          <React.Fragment key={item.id}>
            <Grid item xs={4} sm={3} className={classes.smallText}>
              {item.label}
            </Grid>
            <Grid item xs={8} sm={9}>
              <CKEditor
                editor={ClassicEditor}
                config={editorConfiguration}
                onInit={onEditorInit}
                disabled
                data={props.data[item.id]}
              />
            </Grid>
          </React.Fragment>
        );
      } else if (item.type === "html") {
        return (
          <React.Fragment key={item.id}>
            <Grid item xs={12} sm={12} className={classes.smallText}>
              {item.label}
              <hr/>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.smallText}>
              <div dangerouslySetInnerHTML={{ __html: props.data[item.id] }}></div>
            </Grid>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={item.id}>
            <Grid item xs={4} sm={3} className={classes.smallText}>
              {item.label}
            </Grid>
            <Grid
              item
              xs={8}
              sm={9}
              className={`${classes.bold} ${classes.rightText}`}
            >
              {props.data[item.id]}
            </Grid>
          </React.Fragment>
        );
      }
    }
  };



  return (
    <React.Fragment>
      <Paper className={classes.rightSearchPane}>
        <Grid
          container
          spacing={1}
          direction="column"
          justifyContent="space-between"
          alignItems="stretch"
        >
          <Grid item>
            <Typography
              variant="h4"
              component="h4"
              className={classes.title}
            >
              {props.data?.name || 'No data available'}
            </Typography>
            <Divider variant="middle" className={classes.divider}/>
          </Grid>
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              className={classes.rightText}
            >
              {ModelType && ModelType.map(item => showProperty(item))}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};

export default ShowDetails;
